module.exports = __webpack_public_path__ + "static/media/ParatyTech.09bc455a.ico";